import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { airconCostCalculation } from '../../../js/aircon-cost'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'
import { RequestProvider } from '../../../context/RequestContext'
import { getAppSettings } from '../../../api/app-setting/app-setting'
import { openModal } from '../../../service/modal-service'
import { AnimatePresence, useMotionValueEvent, useScroll } from 'framer-motion'
import { SystemError } from '../../../components/error/SystemError'
import { AirconScope } from '../../../components/index/service-category/aircon-service/AirconScope'
import { AirconItemSelection } from '../../../components/index/service-category/aircon-service/AirconItemSelection'
import { AirconQuickLinks } from '../../../components/index/service-category/aircon-service/AirconQuickLinks'
import { AirconCustomerReviews } from '../../../components/index/service-category/aircon-service/AirconCustomerReviews'
import { AirconGeneralServiceProcess } from '@/index/service-category/aircon-service/AirconGeneralServiceProcess'
import AirconRequestSection from '@/index/service-category/aircon-service/AirconRequestSection'
import { getTestimonials } from 'api/user/profile-api'
import { getAcTestimonials, setAcTestimonials } from 'service/testimonial-store'
import { buildAirconServiceGraph } from 'utils/aircon-page-schema'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const testimonials = getAcTestimonials().length > 0 ? getAcTestimonials() : await getTestimonials("Aircon Services", 0, 6)
    setAcTestimonials(testimonials)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")
    
    const lat = 1.3521
    const lng = 103.8198

    const { month, year } = getArticleDateTime()
    const modifiedDate = reviewedIso(CONTENT_REVIEWED)
    const airconBlogs = blogsMaster['hvac-services'].blogArray
    
    const currencyCd = "SGD"

    let standardServicing = []
    let annualServicing = []
    let chemicalServicing = []
    let overhaulServicing = []    

    airconCostCalculation(currencyCd, annualServicing, standardServicing, chemicalServicing, overhaulServicing)

    return {
        props: {
            requestCategorySettings,
            modifiedDate,
            month,
            year,
            airconBlogs,
            standardServicing,
            annualServicing,
            chemicalServicing,
            overhaulServicing,
            currencyCd,
            testimonials,
            countryName
        },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in
        // - At most once every 10 seconds
        revalidate: 259200, // In seconds
    }
}
export default function Home(props) {
    const router = useRouter()
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings;
    const chemicalServicing = props.chemicalServicing
    const overhaulServicing = props.overhaulServicing
    const standardServicing = props.standardServicing
    const annualServicing = props.annualServicing
    const currencyCd = props.currencyCd
    const testimonials = props.testimonials
    const maxRating = [1, 2, 3, 4, 5]
    const requestType = 'Aircon Services'
    const countryName = props.countryName

    const [ requestForm, setRequestForm ] = useState(router.query.requestForm)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isCustomBook, setIsCustomBook ] = useState(false)
    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})
    const [ waInd, setWaInd ] = useState(false)
    const [ isShowJobScope, setIsShowJobScope ] = useState(false)
    const [ serviceType, setServiceType ] = useState("general")
    const [ unit, setUnit ] = useState("")
    const [ unitType, setUnitType ] = useState("")
    const [ cost, setCost ] = useState("")
    const [ isShowBottomButtons, setIsShowBottomButtons ] = useState(false)
    const [ isShowAirconItemSelection, setIsShowAirconItemSelection ] = useState(false)

    const fetchAppSetting = useCallback(async() => {
        try {
            const appSettings = await getAppSettings(countryName)
            setWaInd(appSettings.waBusinessInd)
        } catch (error) {
            console.log(error);
        }
    }, [countryName])

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
        // setRequestForm(true)
    }

    useEffect(() => {
        if(!countryName) return

        fetchAppSetting()
    }, [countryName, fetchAppSetting])

    const showJobScope = (serviceType) => {
        setServiceType(serviceType)
        openModal(setIsShowJobScope)
    }

    const { scrollY } = useScroll()

    useMotionValueEvent(scrollY, "change", (latest) => {
        if(latest > 100){
            if(!isShowBottomButtons){
                setIsShowBottomButtons(true)
            }
        } else {
            if(isShowBottomButtons){
                setIsShowBottomButtons(false)
            }
        }
    })
    
  return (
    <>
      <Head>
        <title>Aircon Cleaning and Maintenance Service in Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="StringsSG provides aircon maintenance and cleaning services in Singapore. We offer affordable and professional services for all your air conditioner needs. We're here to help you keep your aircon in top condition!"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/cleaning-maintenance-service" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Aircon Cleaning and Maintenance Service in Singapore | StringsSG`}/>
        <meta property="og:description" content="General aircon servicing is a standard process of cleaning and maintenance of the aircon. General servicing is recommended every 3 months for your aircon." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-29T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/repairman-doing-air-conditioner-service.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/repairman-doing-air-conditioner-service.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/cleaning-maintenance-service"/>
        <meta name="twitter:title" content={`Aircon Cleaning and Maintenance Service in Singapore | StringsSG`}/> 
        <meta name="twitter:description" content="General aircon servicing is a standard process of cleaning and maintenance of the aircon. General servicing is recommended every 3 months for your aircon."/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(buildAirconServiceGraph({
            path: '/sg/aircon-servicing-singapore/cleaning-maintenance-service',
            pageName: 'Aircon Cleaning and Maintenance Service in Singapore',
            description: "StringsSG provides aircon maintenance and cleaning services in Singapore. We offer affordable and professional services for all your air conditioner needs. We're here to help you keep your aircon in top condition!",
            serviceName: 'Aircon Cleaning and Maintenance Singapore',
            serviceType: 'Aircon Servicing',
            image: 'https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/repairman-doing-air-conditioner-service.jpg',
            datePublished: '2025-01-29T07:30:46+00:00',
            modifiedDate,
            breadcrumbName: 'Aircon General Servicing',
          })) }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/cleaning-maintenance-service"/>
        </Head>
        <div>
            <RequestProvider>
                <AirconRequestSection
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    setIsQuickBook={setIsQuickBook}
                    isCustomBook={isCustomBook}
                    setIsCustomBook={setIsCustomBook}
                    requestCategorySettings={requestCategorySettings}
                    standardServicing={standardServicing}
                    chemicalServicing={chemicalServicing}
                    overhaulServicing={overhaulServicing}
                    currencyCd={currencyCd}
                    countryName={countryName}
                    requestType={requestType}
                    setIsShowJobScope={setIsShowJobScope}
                    serviceType={serviceType}
                    setServiceType={setServiceType}
                    setUnit={setUnit}
                    setUnitType={setUnitType}
                    setCost={setCost}
                    heroImage="blog/living/aircon/repairman-doing-air-conditioner-service.jpg"
                    title="Aircon Servicing Singapore"
                /> 
                {isShowAirconItemSelection &&
                    <AnimatePresence>
                        <AirconItemSelection setIsShowAirconItemSelection={setIsShowAirconItemSelection} setRequestForm={setRequestForm} setIsCustomBook={setIsCustomBook} setIsQuickBook={setIsQuickBook} openRequestForm={openRequestForm} userId={null}/> 
                    </AnimatePresence>
                }  
            </RequestProvider> 
            <div className='max-w-5xl mx-auto py-6 md:py-8 px-2 space-y-5'>
                <div className='space-y-2 text-center '>
                    {/* Demoted to H2: AirconRequestSection above already renders the
                        page's H1 ("Aircon Servicing Singapore"). Having two H1s on
                        one page is a real SEO defect. */}
                    <h2 className='text-2xl md:text-3xl font-semibold'>Affordable Aircon Cleaning & Maintenance</h2>
                </div>
                <div className='leading-relaxed space-y-3 text-sm'>
                    <p>
                        Aircon cleaning is an important service in Singapore due to the hot and humid climate.  As a result of constant use of the air conditioning systems, 
                        they may accumulate dust, dirt, moisture and other contaminants, reducing their efficiency and lifespan, as well as posing health risks to occupants. 
                        Our professional aircon cleaning services in Singapore can help to clean the air filters, evaporator coils, condenser coils, and other part of the indoor as well as outdoor unit, check for gas leakage and help to prevent any major damage to the aircon by taking necessary actions.
                    </p>
                    <p>
                        In Singapore, general aircon servicing is a standard process of cleaning and maintenance service of the aircon. National Environment Agent of Singapore (NEA) 
                        recommends a standard aircon cleaning service every 3 months for environment safety, energy efficient and optimal cooling performance of the aircon.
                    </p>
                </div>                
            </div>
            <div className='max-w-5xl mx-auto my-10 space-y-5'>
                <h2 className='font-bold text-xl md:text-2xl text-center uppercase'>General Aircon Service Pricing</h2>
                <div className='py-2 px-2 space-y-2 max-w-5xl leading-8 mx-auto'>
                    <div className='grid md:grid-cols-2 py-5 gap-5'>
                        <div>
                            <h3 className='text-gray-400 text-base font-bold text-center'>One-Time Servicing</h3>
                            <div className='flex justify-center'>
                                <table className='w-full sm:w-5/6'>
                                    <thead className='text-orange-600 text-sm border'>
                                        <tr className=''>
                                            <th className='p-2'>No. of Aircons</th>
                                            <th className='p-2'>Pricing</th>
                                        </tr>
                                    </thead>
                                    
                                    <tbody className='text-xs border'>      
                                        {[...standardServicing].map((tran, i) =>                      
                                            <tr key={i} className="border">
                                                <td className="p-2 text-center whitespace-nowrap border">
                                                    {tran.number}
                                                </td>
                                                <td className="p-2 text-center whitespace-nowrap">
                                                    {tran.currencyCd} {tran.rate} 
                                                </td>
                                            </tr>                           
                                        )} 
                                        <tr className="border">
                                            <td className="p-2 text-center border">
                                                more than 5
                                            </td>
                                            <td className="p-2 text-center">
                                                Open request for pricing
                                            </td>
                                        </tr>                    
                                    </tbody>    
                                </table>
                            </div>
                        </div>
                        <div className=''>
                            <h3 className='text-gray-400 text-base font-bold text-center'>Annual Package</h3>
                            <div className='flex justify-center'>
                                <table className='w-full sm:w-5/6'>
                                    <thead className='text-orange-600 text-sm border'>
                                        <tr className=''>
                                            <th className='p-2'>No. of Aircons</th>
                                            <th className='p-2'>4 times/year</th>
                                            <th className='p-2'>3 times/year</th>
                                        </tr>
                                    </thead>
                                    
                                    <tbody className='text-xs border'>      
                                        {[...annualServicing].map((tran, i) =>                      
                                            <tr key={i} className="border">
                                                <td className="p-2 text-center whitespace-nowrap border">
                                                    {tran.number}
                                                </td>
                                                <td className="p-2 text-center whitespace-nowrap border">
                                                    {tran.currencyCd} {tran.threeMonthInterval} 
                                                </td>
                                                <td className="p-2 text-center whitespace-nowrap border">
                                                    {tran.currencyCd} {tran.fourMonthInterval} 
                                                </td>
                                            </tr>                           
                                        )} 
                                        <tr className="border">
                                            <td className="p-2 text-center border">
                                                more than 5
                                            </td>
                                            <td className="p-2 text-center border">
                                                Open request for pricing
                                            </td>
                                            <td className="p-2 text-center">
                                                Open request for pricing
                                            </td>
                                        </tr>                   
                                    </tbody>    
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className='my-5 max-w-md mx-auto'>
                        <h3 className='text-gray-400 text-base font-bold text-center'>Gas To Up Pricing</h3>
                        <div className='flex justify-center'>
                            <table className='w-full'>
                                <thead className='text-orange-600 text-sm border'>
                                    <tr className=''>
                                        <th className='p-2'>Gas type</th>
                                        <th className='p-2'>Pricing</th>
                                    </tr>
                                </thead>
                                
                                <tbody className='text-xs border'> 
                                    <tr className="border">
                                        <td className="p-2 text-center border">
                                            R410A
                                        </td>
                                        <td className="p-2 text-center border">
                                        {currencyCd} 60 - {currencyCd} 150
                                        </td>
                                    </tr>    
                                    <tr className="border">
                                        <td className="p-2 text-center border">
                                            R22
                                        </td>
                                        <td className="p-2 text-center border">
                                        {currencyCd} 40 - {currencyCd} 100
                                        </td>
                                    </tr>                   
                                </tbody>    
                            </table>
                        </div>               
                    </div>
                </div>
            </div>            
            <section className='max-w-5xl mx-auto py-10'>
                <AirconGeneralServiceProcess />
            </section> 
            <AirconCustomerReviews testimonials={testimonials} />
            <div className='max-w-5xl mx-auto py-6 md:py-8 space-y-4 leading-relaxed text-sm'>
                <h2 className='text-xl md:text-2xl text-center uppercase'>
                    <strong>Why you need Aircon Cleaning Service?</strong>
                </h2>
                <div className='py-3 grid grid-cols-1 md:grid-cols-2 gap-3 items-center'>
                    <div className='space-y-2 px-2'>
                        <p><strong>Improved air quality - </strong>
                            Air conditioning units over time accumulates dirt, moisture and other contaminants, which reduces the air quality in your room. Regular aircon cleaning helps to remove these particles and improve the overall air quality.
                        </p>
                        <p className=''><strong>Increased efficiency - </strong>
                        A clean air conditioning unit will operate more efficiently, which helps to lower electricity bills and a longer lifespan for the system. 
                        </p>      
                        <p><strong>Enhanced comfort - </strong>
                            A clean air conditioning unit can provide more consistent and comfortable cooling, as it will be able to maintain the desired temperature more effectively.
                        </p>   
                    </div>
                    <div className='relative w-full h-52 md:h-64'>
                        <Image className='rounded-lg'
                            src={s3Static + "blog/living/cool-air-from-aircon.jpg"}
                            fill
                            sizes="(max-width: 768px) 100vw, 512px"
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='cool air after aircon cleaning'
                        /> 
                    </div>
                </div>
                <div className='space-y-2 px-2'>                                           
                    <p className=''><strong>Health benefits - </strong>
                    Air conditioning units can home to bacteria, mold, and other harmful microorganisms, which can be detrimental to your health. Regular cleaning helps to eliminate these risks.
                    </p>
                    <p className=''><strong>Cost-effective - </strong>                        
                    Regular cleaning can save you from expensive repair costs by preventing major damage to the aircon.
                    </p>     
                </div>
            </div>

            <div className='max-w-5xl mx-auto py-6 md:py-8 space-y-4 leading-relaxed text-sm'>
                <h2 className='text-xl md:text-2xl text-center uppercase'>
                    <strong>Aircon Cleaning companies in Singapore</strong>
                </h2>
                <div className='py-3 grid grid-cols-1 md:grid-cols-2 gap-3 items-center'>
                    <div className='relative w-full h-52 md:h-64'>
                        <Image className='rounded-lg'
                            src={s3Static + "blog/living/aircon-overhaul.jpg"}
                            fill
                            sizes="(max-width: 768px) 100vw, 512px"
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Aircon technician cleaning aircon unit'
                        /> 
                    </div>
                    <div className='space-y-2 px-2'>
                        <p>
                        In Singapore, there are several aircon cleaning contractors who offer different types of aircon servicing as per your requirement and budget. Most companies in Singapore offer general cleaning servicing either one-time or as an annual package.
                        </p>
                        <p>                
                        It is important to consider their experience, reputation, the range of service they offer, pricing, and client reviews, before you choose one company over the other. 
                        It is also important to ensure that the service provider uses safe and effective cleaning methods and products to avoid damage to the unit or harm to occupants.                         
                        </p> 
                    </div>
                </div>
                <div className='space-y-2 px-2'>
                    <p>
                        StringsSG provides high quality aircon servicing across Singapore, with every job done to the service steps and quality standards we define. Once you open a request on our 
                        web or mobile platform, the system will automatically assign a vetted technician who can meet your requirements and budget.
                    </p>
                </div>
            </div>
            <div className='text-center py-6 md:py-8 relative'>
                <div className='relative w-full h-52 md:h-72'>
                    <Image
                        src={s3Static + "blog/living/repairman-doing-air-conditioner-service.jpg"}
                        fill
                        sizes="100vw"
                        style={{objectFit: 'cover', objectPosition: 'center'}} 
                        placeholder='blur'
                        blurDataURL={s3Static + "placeholder.png"}
                        alt='Join us as an Aircon Service Provider - StringsSG'
                    />     
                </div> 
                <div className='absolute flex items-center text-white top-0 bottom-0 left-0 right-0 w-fit mx-auto rounded-3xl'>
                    <Link href="/sg/aircon-servicing-singapore" prefetch={false} className='p-4 rounded-lg bg-black/60 text-xl md:text-2xl'>
                            Request a General Servicing
                    </Link>       
                </div>  
            </div>
            <BlogsList blogs={airconBlogs}/>
            <AirconQuickLinks/>
        </div>  
        {isShowJobScope &&
            <AnimatePresence>
                <AirconScope 
                setIsShowJobScope={setIsShowJobScope}
                serviceType={serviceType} 
                unit={unit} 
                unitType={unitType} 
                cost={cost} />
            </AnimatePresence>
        }                
        <AnimatePresence>
            {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
        </AnimatePresence>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
